// API Models

import * as moment from 'moment';
import { ReorderDetails } from '.';

export interface ApiDaysOnHandRequiredRequest {
  patientId: number;
  supplies: {
    itemId: number;
  }[];
}

export interface ApiDaysOnHandRequiredResponse {
  itemId: number;
  daysOnHandRequired: boolean;
}

export interface ApiFrequenciesRequiredRequest {
  patientId: number;
  dateOfService?: string;
  supplies: {
    itemId: number;
    daysOnHand?: number;
  }[];
}

export interface ApiFrequenciesRequiredResponse {
  cgmSiteChgFreqRequired: boolean;
  pumpSiteChgFreqRequired: boolean;
  patientTestFreqRequired: boolean;
}

// Front End Models

export interface DaysOnHandRequired extends ApiDaysOnHandRequiredResponse {
  // Computed
  itemDescription: string;
  estimatedDaysOnHand: number | null;
}

export interface FrequenciesRequired extends ApiFrequenciesRequiredResponse {}

// Mappers

export const mapDaysOnHandRequired = (
  doh: ApiDaysOnHandRequiredResponse,
  reorder: ReorderDetails
): DaysOnHandRequired => {
  const reorderTargetedShipDate = reorder.targetedShipDate;
  const reorderItem = reorder.items.find((i) => i.id === doh.itemId);

  return {
    itemId: doh.itemId,
    itemDescription: reorderItem?.description || '',
    daysOnHandRequired: doh.daysOnHandRequired,
    estimatedDaysOnHand: doh.daysOnHandRequired
      ? reorderTargetedShipDate
        ? Math.max(moment(reorderTargetedShipDate).startOf('day').diff(moment().startOf('day'), 'days'), 0)
        : 0
      : null,
  };
};

export const mapFrequenciesRequired = (fr: ApiFrequenciesRequiredResponse): FrequenciesRequired => fr;
